module.exports = {"data":{"site":{"siteMetadata":{"title":"Paul D Kimbrel","subtitle":"Web Developer, Technical Architect, Sound Engineer"}}},"layoutContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/layout-index.json
// module id = 109
// module chunks = 60335399758886 114276838955818